import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  APIoperationsAll: [],
  APIoperations: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const APIoperationsSlice = createSlice({
  name: "APIoperations",
  initialState,
  reducers: {
    setAPIoperationsAll: (state, action) => {
      state.APIoperationsAll = action.payload;
    },
    setAPIoperations: (state, action) => {
      state.APIoperations = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setAPIoperationsAll,
  setAPIoperations,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = APIoperationsSlice.actions;

export default APIoperationsSlice.reducer;
